import classNames from 'classnames';
import parseHtml from 'html-react-parser';
import { reduce } from 'lodash';
import { useMemo, useRef } from 'react';

import * as registry from './registry';
import './style.m.less';

const registeredFeatures = registry.getFeatures();

const defaultProps = registeredFeatures.defaultProps;

const FEATURES = registeredFeatures.callbacks;

function RichText(passedProps) {
    const ref = useRef();
    const props = useMemo(() => ({ ...defaultProps, ...passedProps }), [passedProps]);
    const replace = useMemo(() => getReplaceWithFeatures(props), [props]);

    const { value, className, style } = props;
    const htmlString = parseWithFeatures(value, props);
    return (
        <span ref={ref} className={classNames(className, 'rich-text-view')} style={style}>
            {htmlString && parseHtml(htmlString, { replace })}
        </span>
    );
}

export default RichText;

const IDENTITY = t => t;

export function parseWithFeatures(content, features) {
    if (!content) {
        return content;
    }

    return reduce(
        FEATURES,
        (mem, feature, name) => {
            const args = features[name];
            const fn = feature.onParse || IDENTITY;
            return args ? fn(mem, args) : mem;
        },
        content
    );
}

function getReplaceWithFeatures(features) {
    const onMountFns = Object.entries(FEATURES)
        .map(([name, feature]) => {
            const args = features[name];
            if (!feature.onMount || !args) {
                return;
            }

            return feature.onMount;
        })
        .filter(Boolean);
    return el => onMountFns.map(fn => fn(el)).find(Boolean);
}
